import { useVideoCall as useVideoCallCore } from '@ngsos/portal-core/video';
import type { UseVideoCallResult } from '@ngsos/portal-core/video';
import type { IncidentRealtime } from '@ngsos/portal-core/chat';

import { getAccessToken } from '@/api/auth';
import type { LiveVideo } from '@/signalr';
import { getVideoOptions } from '@/lib/video/config';
import { mediasoupPlatform } from '@/lib/video/mediasoupService';
import { recordingPlayback } from '@/lib/video/playbackService';
import { reportUnhandledError } from '@/lib/errors/unhandledErrors';

export type UseVideoCallOptions = {
  liveVideo: LiveVideo;
  realtime: IncidentRealtime | null;
  onVideoExpandedChanged: (expanded: boolean) => void;
};

async function accessTokenFactory(): Promise<string> {
  const accessToken = await getAccessToken();
  if (accessToken == null) {
    throw new Error('Cannot join the video signalling without an access token.');
  }
  return accessToken;
}

export function useVideoCall({ liveVideo, realtime, onVideoExpandedChanged }: UseVideoCallOptions): UseVideoCallResult {
  return useVideoCallCore({
    liveVideo,
    realtime,
    onVideoExpandedChanged,
    platform: mediasoupPlatform,
    recordingPlayback,
    videoServerUrl: getVideoOptions().VIDEO_SERVER_URL,
    accessTokenFactory,
    reportUnhandledError,
  });
}
